
require('with-global-jquery')(function () {
	module.exports = require('bootstrap');
});

